import React from 'react'
import PdImage from '@components/pd-image/pd-image'
import { useRouter } from 'next/router'
import { useTranslations } from 'next-intl'
import { EventReportManager } from '@/event-report/event-report-manager'
import {
  IProductParamsPanelProps,
  Theme,
  paddingTopClassMap,
  paddingBottomClassMap,
} from '@common/pd-meta-components-types'
import SemanticText from '@/components/standard/semantic-text'

const PdProductParamsPanel = ({
  theme = Theme.Dark,
  title,
  titleTag,
  backgroundClassName = 'bg-container-primary',
  imgUrl = '',
  paramsList = [],
  btntext,
  iframe,
  // titleText,
  // lightBgc,
  // darkBgc,
  robot,
  paddingTop = 'px120',
  paddingBottom = 'px120',
}: IProductParamsPanelProps) => {
  const t = useTranslations()
  const router = useRouter()
  function fireContactEvent() {
    const event = { action: '', data: { event: 'initiate_lead' } }
    EventReportManager.getInstance().fireEventImmediately(event, true)
    router.push({ pathname: '/contact-us', query: robot ? { robot } : {} })
  }
  return (
    <div className={['w-full flex flex-col items-center', `pd-theme-${theme}`, backgroundClassName].join(' ')}>
      <div
        className={[
          'flex flex-col w-full px-6',
          'laptop:w-300 laptop:p-0',
          paddingTopClassMap[paddingTop],
          paddingBottomClassMap[paddingBottom],
        ].join(' ')}
      >
        <div className={['w-full flex flex-col laptop:flex-row'].join(' ')}>
          <div className={['text-center w-full h-327px mb-8', 'laptop:w-370px laptop:m-0 laptop:h-[25vw]'].join(' ')}>
            <PdImage src={imgUrl} enableMask={false} object="contain" width={'100%'} height={'100%'} />
          </div>
          <div className={['laptop:flex-1 laptop:mt-0', ' -mt-3'].join(' ')}>
            {title && (
              <SemanticText
                as={titleTag}
                defaultTag="div"
                className={[
                  'text-fc-primary',
                  'border-b border-bd-primary font-semibold',
                  'laptop:text-40 laptop:pb-6',
                  'text-24 pb-3',
                ].join(' ')}
              >
                {title}
              </SemanticText>
            )}
            <div className={['laptop:justify-between laptop:flex-row laptop:flex-wrap', 'flex flex-col'].join(' ')}>
              {paramsList.map((item, index) => (
                <div
                  key={index}
                  className={[
                    'mt-3',
                    theme === 'dark' ? 'border-white/50' : 'border-white/50',
                    'laptop:w-90 laptop:flex laptop:flex-col laptop:mt-11 laptop:border-none',
                  ].join(' ')}
                >
                  <p className={['m-0 text-14', 'laptop:text-base', 'text-fc-secondary'].join(' ')}>{item.label}</p>
                  <div className={['flex flex-col mt-7px mb-10px', 'laptop:mt-3 laptop:mb-0', item.gap].join(' ')}>
                    {item.value.map((e, i) => (
                      <span
                        key={i}
                        className={['text-12', 'laptop:text-base laptop:font-medium', 'text-fc-primary'].join(' ')}
                      >
                        {e}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
              <div className={['laptop:mt-20 laptop:w-full', 'mt-15'].join(' ')}>
                {iframe ? (
                  <a
                    href={'https://www.pudurobotics.com/zh/cooperate'}
                    target="_blank"
                    rel="noreferrer"
                    className={[
                      'text-white',
                      'bg-pdblue text-center inline-block w-full py-4 rounded-lg text-18 cursor-pointer',
                      'laptop:inline laptop:rounded laptop:py-5 laptop:px-98px laptop:text-20',
                    ].join(' ')}
                  >
                    {btntext || t('parameterData.btntext')}
                  </a>
                ) : (
                  <span
                    onClick={fireContactEvent}
                    className={[
                      'text-white',
                      'bg-pdblue text-center inline-block w-full py-4 rounded-lg text-18 cursor-pointer',
                      'laptop:inline-black laptop:rounded laptop:py-2 laptop:px-6 laptop:text-16 laptop:w-326px',
                    ].join(' ')}
                  >
                    {btntext || t('parameterData.btntext')}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default PdProductParamsPanel
